import React, { useState, useEffect, useCallback } from "react";

import { withRouter } from "react-router";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/core components
import AllInclusive from "@material-ui/icons/AllInclusive";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import loadContent from "core-module/hoc/loadContent";

import * as api from "core-module/services/api";

import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import { addNewID } from "core-module/services/ids/actions";
import store from "store";

const importedStyle = customCheckboxRadioSwitch;

const styles = {
  switchBase: importedStyle.switchBase,
  switchChecked: importedStyle.switchChecked,
  switchIcon: importedStyle.switchIcon,
  switchIconChecked: importedStyle.switchIconChecked,
  switchBar: importedStyle.switchBar,
  label: {
    ...importedStyle.label,
    marginLeft: "10px",
  },
  cardIconTitle: dashboardStyle.cardIconTitle,
  myBlock: {
    margin: "20px",
  },
  ...buttonStyle,
};

const UnlimitedModeCard = (props) => {
  const { classes, ids, history, location } = props;

  //const dn_limit = props.getData("unlimited_speed_dn");
  //const up_limit = props.getData("unlimited_speed_up");

  const [alert, setAlert] = useState(null);
  const unlimitedSwitchDisabled = props.getData("switch_disabled", "value");
  const switchValue = props.getData("slowdown_mode", "value");

  const handleSlowDownSwitch = useCallback(async () => {
    const handleConfirm = async () => {
      setAlert(
        <SweetAlert
          info
          style={{
            display: "block",
            top: "5%",
            maxWidth: "90%",
            marginTop: "1%",
          }}
          title="Applying changes"
          showConfirm={false}
          onConfirm={() => null}
        >
          {"Please wait while we apply this changes"}
        </SweetAlert>
      );

      const boolIn = !switchValue;

      await api.postNload(
        `user.${ids.user}/slowdown`,
        {
          slowdown_mode: boolIn,
        },
        0,
        [`user.${ids.user}/slowdown`, "slowdown"]
      );

      setTimeout(() => {
        setAlert(
          <SweetAlert
            success
            style={{
              display: "block",
              top: "5%",
              maxWidth: "90%",
              marginTop: "1%",
            }}
            title="Success"
            showConfirm={false}
            onConfirm={() => null}
          >
            {boolIn ? "Unlimited Mode turned on!" : "Unlimited Mode turned off"}
          </SweetAlert>
        );
        setTimeout(() => {
          setAlert(null);
          history.push(location.pathname, {});

          store.dispatch(addNewID("user", ""));
          store.dispatch(addNewID("user", ids.user));
        }, 2000);
      }, 4000);
    };

    setAlert(
      <SweetAlert
        info
        style={{
          display: "block",
          top: "5%",
          maxWidth: "90%",
          marginTop: "1%",
        }}
        title={switchValue ? "Turn Off?" : "Turn On?"}
        onConfirm={handleConfirm}
        onCancel={() => {
          if (
            location.state != null &&
            "action" in location.state &&
            location.state.action === "unlimited"
          ) {
            //Make sure the action state is not there. Otherwise it gets stuck
            history.push(location.pathname, {});
          }
          setAlert(null);
        }}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.warning}
        confirmBtnText="Confirm"
        cancelBtnText="Cancel"
        showCancel
      >
        {switchValue ? (
          <p>This may momentarily interrupt your connection.</p>
        ) : (
          <p>
            In Unlimited mode, your internet speed will be
            <b> substantially</b> reduced.
            <br />
            This may momentarily interrupt your connection.
          </p>
        )}
      </SweetAlert>
    );
  }, [switchValue, ids, classes, history, location]);

  useEffect(() => {
    if (
      location.state != null &&
      "action" in location.state &&
      location.state.action === "unlimited"
    ) {
      if (switchValue === true) {
        setAlert(
          <SweetAlert
            info
            style={{
              display: "block",
              top: "5%",
              maxWidth: "90%",
              marginTop: "1%",
            }}
            title={"Processing..."}
            onConfirm={() => setAlert(null)}
            confirmBtnCssClass={classes.button + " " + classes.success}
            confirmBtnText="Ok"
          >
            You are already in Unlimited Mode. The recent changes can take up to
            1 minute to take effect.
          </SweetAlert>
        );
      } else {
        handleSlowDownSwitch();
      }
    }
  }, [handleSlowDownSwitch, classes, location, switchValue]);

  if (props.getData("canslowdown", "value") === false) {
    return null;
  }

  return (
    <div>
      {alert}
      <Card>
        <CardHeader color="primary" icon>
          <CardIcon color="primary">
            <AllInclusive />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Unlimited Mode</h4>
        </CardHeader>
        <CardBody>
          <div className={classes.myBlock}>
            <FormControlLabel
              control={
                <Switch
                  checked={props.getData("slowdown_mode", "value")}
                  onChange={handleSlowDownSwitch}
                  disabled={unlimitedSwitchDisabled}
                  value={switchValue}
                  color="primary"
                  classes={{
                    checked: classes.switchChecked,
                  }}
                />
              }
              classes={{
                label: classes.label,
              }}
              label={
                <p>
                  Unlimited mode is {props.getData("slowdown_mode")}. In
                  Unlimited mode, your internet speed will be
                  <b> substantially</b> reduced. Usage while in Unlimited mode
                  will NOT be counted against your monthly usage allowance.
                  Unlimited mode allows you to continue using your internet
                  connection for basic email and browsing once you've hit your
                  cap, or to save your cap for what matters most to you.
                </p>
              }
            />
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default withStyles(styles)(
  withRouter(loadContent("user.session/slowdown", UnlimitedModeCard))
);
